import script from "./DocumentClassifier.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentClassifier.vue?vue&type=script&setup=true&lang=js"

import "./DocumentClassifier.vue?vue&type=style&index=0&id=6d83ce58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d83ce58"]])

export default __exports__